export default __webpack_public_path__ + "static/media/step-3.24ca6bb4.svg";